<template>
  <div>
    <div class="header-container" v-if="dataTemplateQMACabecalho.length > 0">
      <draggable
        v-model="dataTemplateQMACabecalho"
        @change="onDragChange"
        class="container-assinatura-list"
        ghost-class="ghost"
      >
      <div class="container-cabecalho" v-for="(data,index) in dataTemplateQMACabecalho" v-bind:key="index">
        <div class="button-epi-selecionado">
            <div v-if="data.edicao != false">
              <div class="button-lista" :id="data.id" @click="AdicionarItenParaExclusaoDaEdicao(data)"><i class="fas fa-check" style="color: rgb(19, 59, 26); font-size: 9px;" v-if="data.check === true"></i></div>
            </div>
          </div>
        <div class="cabecalho">
          <img class="img_tipo_campo" :src="data.tipo === 0 ? imgTexto : data.tipo === 1 ? imgNumero : imgData"  v-b-tooltip.hover :title="data.tipo  === 0 ? 'Campo Texto' : data.tipo === 1 ? 'Campo Número' : 'Campo Data'">
            {{data.nivelPrioridade === undefined || data.nivelPrioridade === 0 ? data.descricao : data.nivelPrioridade + ' - ' + data.descricao }}
          <div class="label_descricao" v-if="data.edicao != false">
            <div class="tag">
              <div class="tag_identificacao" :style="{'background-color': data.colorStatus, 'color': data.colorFonte}"> {{ data.descricaoEdicao }}</div>
            </div>
          </div>
        </div>

        <div class="buttons-containers">
          <div class="delete-container">
            <div
              @click="excluirItemCabecalho(data.id)"
              class="font font-bold  excPreRequisito"
              style="color: rgb(136, 22, 22);"
              v-if="data.status >= 0"
            >
              <i v-b-tooltip.hover title="Excluir item" class="fas fa-trash"></i>
            </div>
          </div>

          <div class="switch-container" v-if="data.edicao === false" >
            <label class="switch">
              <input type="checkbox" @click="CheckboxAtivacaoInativacao(data.id, data.status)" :id="data.id" :checked="data.status" :disabled="data.edicao === true ? true : false">
              <span class="slider round"></span>
            </label>
          </div>

        </div>

      </div>
    </draggable>
    </div>

    <div class="container_img" v-else>
      <img  class="img_notFound" :src="notFound">
      <div class="titulo_sem_registro">Nenhum registro encontrado</div>
      <div class="subtitulo_sem_registro">Adicione um novo registro para iniciar o cabeçalho</div>
      <button class="button" @click="addcabecalho">
          <i class="fas fa-plus"></i>ADICIONAR REGISTRO
      </button>
    </div>
  </div>

  </template>

<script>
import headerTemplate from './headerTemplate'
export default headerTemplate
</script>
  <style scoped>

  .buttons-containers{
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 0.5rem;
  }

  .ghost {
    opacity: 0.5;
    background: #f4f4f4;
  }
  .img_tipo_campo {
    width: 2rem;
    padding: 0 0.4rem 0 0.4rem
  }
  .button-epi-selecionado{
    display: flex;
    width: 5%;
    align-items: center;
    justify-content: center;
  }
  .button-lista{
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1rem;
    height: 1rem;
    border-radius: 12%;
    border: 1px solid #c4c4c4;
  }
  .button-lista.clicked {
    background-color: rgb(203, 233, 207); /* Cor de fundo alterada */
    border: 1px solid rgb(81 134 91)
  }
  .check-inpu{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 6%;
  }
  .label_descricao{
    padding-left: 1rem;
    margin-right: 1rem;
    margin-left: 1rem;
    border-left: 1px solid rgb(205, 205, 205);
  }
  .header-container{
    margin-top: 1rem;
    width: 100%;
  }
  .tag{
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    border-radius: 20px;
    height: 100%;
  }
  .tag_identificacao{
    width: fit-content;
    height: 1.6rem;
    text-align: center;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font: normal normal 600 10px / 24px Segoe UI;
    padding: 0 5px 0 5px;
    font-weight: bold;
  }
  .container-cabecalho{
    display: flex;
    padding: 0.3rem 0 0.3rem 0;
    border-bottom: 1px solid rgb(237 237 237);
    height: 3rem;
    width: 100%;
  }
  .cabecalho {
    display: flex;
    justify-content: initial;
    align-items: center;
    width: 100%;
  }
  .switch-container {
    margin-top: 5px;
    display: flex;
    justify-content: end;
    width: 100%;
  }

  .button{
    margin-top: 2rem;
    font: normal normal 600 12px / 21px Segoe UI;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 15rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    height: 37px;
    background-color: #008144;
    color: white;
   }
  .container_img{
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    margin-top: 5rem;
    margin-bottom: 5rem;
    align-items: center;
    flex-direction: column;
  }
  .img_notFound{
    width: 20%;
    height: fit-content;
  }
  .titulo_sem_registro {
    margin-top: 1rem;
    font: normal normal normal 28px/33px Segoe UI;
    color: #008148;
  }
  .subtitulo_sem_registro {
    font: normal normal normal 16px/33px Segoe UI;
    letter-spacing: -0.3px;
    color: #4F4C4D;
  }

/* Estilização switch */

.switch {
  position: relative;
  display: inline-block;
  width: 58px;
  height: 31px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #eeeeee;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: #666666;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #CBE9CF;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  background-color: #1C6228;
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/headerTemplate/headerTemplate.vue